import { FC } from "react";
import { useAuth } from "../../hooks/useAuth";
import Login from "../pages/login/Login";
import environment from "../../environment/environment";

const RequireAuth: FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAuthenticated, user, isLoading } = useAuth();

  if (environment.publicMode) {
    return children;
  }

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated || !user) {
    const returnUrl = window.location.pathname;
    if (returnUrl !== '/login') {
      localStorage.setItem('redirectUri', returnUrl);
    }
    return <Login />;
  }

  return children;
};

export default RequireAuth;